import React, { useEffect } from 'react'
import { Box, CloseIcon } from '@usap/uicomponents'
import { BoxWithPointer } from './StyledCSS'
import { StyledLayer, PopUpClose, PopUpCloseIcon } from './style/PopUpLayer.css'

export default function PopUpLayer({
  flag,
  closePopUp,
  PopUpComponent,
  enableButton,
  full = false,
  isClose = true,
  fitMobileWidth = false,
  ...rest
}) {
  useEffect(() => {
    if (__BROWSER__) {
      if (flag) document.body.classList.add('overflowHidden')
      else document.body.classList.remove('overflowHidden')
    }
  }, [flag])

  return (
    <Box animation={flag ? 'fadeIn' : 'fadeOut'}>
      {flag && (
        <StyledLayer
          margin={full ? '0px' : 'small'}
          responsive={false}
          animation="fadeIn"
          full={full}
          fitMobileWidth={fitMobileWidth}
          // TODO: memoize callback
          onEsc={() => {
            closePopUp(false)
            if (enableButton) enableButton(false)
          }}
          // TODO: memoize callback
          onClickOutside={() => {
            closePopUp(false)
            if (enableButton) enableButton(false)
          }}
        >
          <PopUpComponent
            closePopUp={closePopUp}
            enableButton={enableButton}
            {...rest}
          />

          {isClose && (
            <PopUpClose>
              <BoxWithPointer align="center">
                <PopUpCloseIcon
                  icon={CloseIcon}
                  size="36px"
                  // TODO: memoize callback
                  onClick={e => {
                    e.stopPropagation()
                    closePopUp(false)
                    if (enableButton) enableButton(false)
                  }}
                />
              </BoxWithPointer>
            </PopUpClose>
          )}
        </StyledLayer>
      )}
    </Box>
  )
}
